import { createBrowserRouter } from "react-router";
import { routesConfig } from "config/app-config";
import { RootWithErrorBoundary } from "components/Layout";
import { BaseErrorPage, NotFoundErrorPage } from "utils/errorHandling";
import { HomePageWithErrorBoundary } from "pages/Home/HomePage";
import { NouveauContactMetierPageWithErrorBoundary } from "pages/NouveauContactMetier/NouveauContactMetierPage";
import { SaisieEnMasseContactMetierPageWithErrorBoundary } from "pages/SaisieEnMasseContactMetier/SaisieEnMasseContactMetier";

export const authenticatedRouter = createBrowserRouter([
  {
    element: <RootWithErrorBoundary />,
    errorElement: <BaseErrorPage />,
    children: [
      {
        path: routesConfig.home.path,
        element: <HomePageWithErrorBoundary />,
      },
      {
        path: routesConfig.nouveauContactMetier.path,
        element: <NouveauContactMetierPageWithErrorBoundary />,
      },
      {
        path: routesConfig.saisieEnMasse.path,
        element: <SaisieEnMasseContactMetierPageWithErrorBoundary />,
      },
      {
        path: routesConfig.any.path,
        element: <NotFoundErrorPage />,
      },
    ],
  },
]);
